import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Field } from '@bd/bdui-forms';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

function FileInput(props) {
  return (
    <Field field={props.field}>
      { fieldApi => {
        const { onChange, onBlur, field, ...rest } = props;
        const { setValue, setTouched } = fieldApi;

        return (
          <div>
            <input
              {...rest}
              type="file"
              onChange={e => {
                if (get(e, 'target.files[0]')) {
                  getBase64(get(e, 'target.files[0]'))
                    .then(b64Value => {
                      setValue(b64Value);
                      if (onChange) {
                        onChange(e.target.value, e);
                      }
                    })
                    .catch(() => {});
                } else if (onChange) {
                  onChange(e.target.value, e);
                }
              }}
              onBlur={e => {
                setTouched();
                if (onBlur) {
                  onBlur(e);
                }
              }}
            />
          </div>
        );
      }}
    </Field>
  );
}

FileInput.propTypes = {
  field: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

FileInput.defaultProps = {
  onChange: undefined,
  onBlur: undefined,
};

export default FileInput;



// WEBPACK FOOTER //
// ./src/pages/Warranty/FileInput.js